const HUE = 250;
const SATURATION = 97;
const DEFAULT_LIGHTNESS = 62;
const LIGHTNESS_MIN = 15;
const LIGHTNESS_MAX = 85;

/**
 * Generates a consistent color for a user within a set of users.
 * All colors are variations of the primary color (same hue, different lightness).
 * The lightness is distributed evenly based on the user's sorted position.
 */
export function getUserColor(userId: string, allUserIds: string[]): string {
  const defaultColor = `hsl(${HUE}, ${SATURATION}%, ${DEFAULT_LIGHTNESS}%)`;
  if (allUserIds.length === 0) return defaultColor;

  const sortedIds = [...allUserIds].sort();

  const index = sortedIds.indexOf(userId);
  if (index === -1) return defaultColor;

  const count = sortedIds.length;
  if (count === 1) {
    return defaultColor;
  }

  // Distribute lightness evenly across users
  const t = index / (count - 1);
  const lightness = Math.round(
    LIGHTNESS_MIN + (LIGHTNESS_MAX - LIGHTNESS_MIN) * t
  );

  return `hsl(${HUE}, ${SATURATION}%, ${lightness}%)`;
}
